import { render, staticRenderFns } from "./ExamWatchDetails.vue?vue&type=template&id=3845a6f8&scoped=true&"
import script from "./ExamWatchDetails.vue?vue&type=script&lang=js&"
export * from "./ExamWatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExamWatchDetails.vue?vue&type=style&index=0&id=3845a6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845a6f8",
  null
  
)

export default component.exports